import { useQuery, gql } from "@apollo/client"
import { COACH_TOOLS_API } from "../../apolloClient"

export const PTM_MEMBERSHIP_APPLICATIONS_QUERY = gql`
  query ProspectMembershipApplications {
    membershipApplications {
      id
      applicationType
      status
      updatedAt
    }
  }
`

export const withPtmApplicationsQuery = Component => props => {
  const { error, data, refetch, networkStatus } = useQuery(
    PTM_MEMBERSHIP_APPLICATIONS_QUERY,
    {
      context: {
        api: COACH_TOOLS_API,
      },
      notifyOnNetworkStatusChange: true,
    },
  )
  const loading = !data && !error
  const membershipApplications = data?.membershipApplications || []

  return (
    <Component
      {...{
        membershipApplications,
        ptmApplicationsLoading: loading,
        ptmApplicationsError: error,
        refetchPtmApplications: refetch,
        ptmApplicationsNetworkStatus: networkStatus,
        ...props,
      }}
    />
  )
}
